// Turn one or more schema.org nodes into the exact JSON string that goes
// inside <script type="application/ld+json">. Used by <Seo> on the client
// and by the server's crawler injection — same wrapping, same escaping, so
// the two <script> contents are byte-identical and react-helmet-async
// adopts the injected one on hydration instead of replacing it.
export const wrapGraph = (nodes) => {
  const list = (Array.isArray(nodes) ? nodes : [nodes]).filter(Boolean);
  if (list.length === 0) return null;
  return list.length === 1
    ? { "@context": "https://schema.org", ...list[0] }
    : { "@context": "https://schema.org", "@graph": list };
};

// JSON, with every "<" escaped so a stray "</script>" inside a field value
// can't break out of the script element.
export const ldJsonString = (nodes) => {
  const graph = wrapGraph(nodes);
  return graph ? JSON.stringify(graph).replace(/</g, "\\u003c") : null;
};
